(function($) {

	'use strict';

	var init = function() {

        if($('.mec-events-meta-group-booking').length > 0) {
            addReturnButton();
            if($('.mec-ticket-unavailable-spots.info-msg:not(.mec-util-hidden)').length > 0) {
                showUnavailableNotice();
            }
        }
        
    };
    
    var addReturnButton = function() {

        var getUrl = window.location;
        var baseUrl = getUrl .protocol + "//" + getUrl.host;
        var newUrl = baseUrl + '/visiter-lusine/reserver-une-visite/';

        $('<a href="' + newUrl + '" class="mec-book-form-back-button">PRÉCÉDENT</a>').insertAfter('.mec-google-recaptcha');
    }

    var showUnavailableNotice = function() {

        var unavailable = $('.mec-event-ticket-name').text();

        var notice = 'La <strong>' + unavailable.toLowerCase() + '</strong> n\'est pas disponible. Veuillez choisir une autre date';

        $('.mec-ticket-unavailable-spots.info-msg').append('<span>' + notice + '</span>');
    }

	$(document).ready(function() {
		init();
	});

})(jQuery);